module.exports = __webpack_public_path__ + "static/img/image-2.04dcc858.png";